import { mapGetters, mapActions } from "vuex";
import leaveRequests from "@/services/leaveRequest";
import Utils from "@/mixins/Utils";
import { ALERT_TYPES } from "@/constants/variables";
import {
  LEAVE_REQUEST_STATUSES,
  LEAVE_REQUEST_TYPE,
  CONDITION_KEY
} from "../../constants/variables";
import conditionHelper from "../../helpers/condition";
import agencyService from "@/services/agency";
import terminology from "@/mixins/terminology";
import downloadService from "../../services/download";
import moment from 'moment-timezone';
import date from '../../mixins/date';
moment.tz.setDefault('Europe/Paris')
export default {
  mixins: [Utils, date],
  computed: {
    ...mapGetters({
      getLeaveRequestSelected: "getLeaveRequestSelected",
      leaveRequestsTypes: "leaveRequestsTypes",
      leaveRequestsStatus: "leaveRequestsStatus",
      leaveRequestStatuses: "leaveRequestStatuses",
    }),
    isShowMaxSoldeDay() {
      return (
        this.leaveRequestToEdit.pkIxLeaveType ===
        LEAVE_REQUEST_TYPE.CONGES_PAYES
      );
    },
    isShowAgencyPhone() {
      return (
        this.leaveRequestToEdit.pkIxLeaveType ===
          LEAVE_REQUEST_TYPE.CONGES_PATERNITE ||
        this.leaveRequestToEdit.pkIxLeaveType ===
          LEAVE_REQUEST_TYPE.CONGES_MATERNITE
      );
    },
 
    invalidFeedbackStartDate() {
      if (!this.leaveRequestToEdit.startDate) {
        return this.$t("invalid-feedback-start-date");
      }
    },
    invalidFeedbackEndDate() {
      if (!this.leaveRequestToEdit.endDate) {
        return this.$t("invalid-feedback-end-date-required");
      }
      return this.$t("invalid-feedback-end-date-compare");
    },
    canBeDeleted() {
      // Validé, Refusé or Validé - En Attente d'Annulation, should not be able to be deleted.
      const canBeDeltedStatuses = [LEAVE_REQUEST_STATUSES.WAIT_FOR_VALIDATION];
      return (
        this.getLeaveRequestSelected &&
        canBeDeltedStatuses.includes(
          this.getLeaveRequestSelected.pkIxLeaveStatut
        ) &&
        this.$route.params.type === "edit"
      );
    },
    editable() {
      const editableStatuses = [LEAVE_REQUEST_STATUSES.WAIT_FOR_VALIDATION];
      return (
        (this.getLeaveRequestSelected &&
          editableStatuses.includes(
            this.getLeaveRequestSelected.pkIxLeaveStatut
          )) ||
        this.$route.params.type === "created"
      );
    },
    cancelable() {
      const cancelableStatuses = [LEAVE_REQUEST_STATUSES.VALIDATED];
      return (
        conditionHelper(CONDITION_KEY.LEAVE_REQUEST_CANCELABLE) &&
        this.getLeaveRequestSelected &&
        cancelableStatuses.includes(
          this.getLeaveRequestSelected.pkIxLeaveStatut
        ) &&
        this.$route.params.type === "edit"
      );
    },
  },
  async created() {
    await leaveRequests.getCounter().then((res) => {
      this.maxDateSolde = res.data.soldeConges ? res.data.soldeConges : 0;
    });
    await this.getMyAgency();
    try {
      if (!this.leaveRequestsTypes.length) {
        await this.fetchLeaveRequestType();
      }

      this.options = this.leaveRequestsTypes;
      if (!this.leaveRequestStatuses.length) {
        this.getLeaveRequestStatuses();
      }
      if (this.$route.params.type === "edit") {
        const queryId = Number(this.$route.params.id);
        if (queryId) {
          if (
            this.getLeaveRequestSelected &&
            queryId === this.getLeaveRequestSelected.pkLeaveRequest
          ) {
            this.leaveRequestToEdit = this.getLeaveRequestSelected;
          } else {
            const { data } = await leaveRequests.getListLeaveRequests();
            this.leaveRequestToEdit = data.find((item) => {
              return item.pkLeaveRequest === Number(this.$route.params.id);
            });

            this.$store.commit(
              "LEAVE_REQUEST_SELECTED",
              this.leaveRequestToEdit
            );
          }
          if (
            this.leaveRequestToEdit.filePath &&
            this.leaveRequestToEdit.filePath.length > 0
          ) {
            this.isLoading = true;
            for(let i = 0; i < this.leaveRequestToEdit.filePath.length; i++) {
              let showImage = false;
              
              if (
                this.leaveRequestToEdit.filePath[i].includes("png") ||
                this.leaveRequestToEdit.filePath[i].includes("gif") ||
                this.leaveRequestToEdit.filePath[i].includes("jpeg") ||
                this.leaveRequestToEdit.filePath[i].includes("svg")
              ) {
                showImage = true;
              }
              if(i===0) {
                this.isShowImage = showImage;
              }else {
                this.isShowSecondImage = showImage;
                
              }
              await this.checkFileExistanceDownload(
                this.leaveRequestToEdit.filePath[i],
                null,
                i == 0 ? true : false
              );
            }
          } else {
            this.isLoading = false;
            this.isChangeFile = true;
          }
          this.onchangeStartDate(null);
         
        } else {
          this.leaveRequestToEdit = this.getLeaveRequestSelected;
        }
        if (!this.leaveRequestToEdit) {
          this.$router.push({ name: "employee-leave" });
        }
        this.formatData();
      } else {
        this.leaveRequestToEdit = {
          pkIxLeaveType: null,
          startDate: "",
          endDate: "",
          message: "",
        };
        this.isLoading = false;
      }
    } catch (error) {
    } finally {
      
    }
  },
  data() {
    return {
      alert: {},
      options: [],
      text: null,
      leaveRequestToEdit: {},
      isLoading: true,
      moment,
      show: false,
      isDisabled: false,
      maxDateSolde: 0,
      isExceedMaxDateSolde: false,
      numberDateOff: 0,
      agency: null,
      isDisableEndPicker: false,
      tempPhoto: "",
      tempSecondPhoto: "",
      validatedPhoto: false,
      maxSizeUploadImage: 0,
      uploadedFirstFile: null,
      uploadedSecondFile: null,
      isShowImage: false,
      isShowSecondImage: false,
      isShowFirstUploadFile: false,
      isShowSecondUploadFile: false,
      tempFile: null,
      tempSecondFile: null,
      isDisabledEndDatePicker: false,
      fileName: "",
      fileSecondName: "",
    };
  },
  methods: {
    ...mapActions(["getLeaveRequestStatuses", "fetchLeaveRequestType"]),
    getMyAgency() {
      const vue = this;
      agencyService
        .getAgence()
        .then((res) => {
          vue.agency = res.data.agency || {};
        })
        .catch((err) => {
          // Handler error
        });
    },
    isCheckRequiredFile() {
   
      if (this.isShowFirstUploadFile && !this.isShowSecondUploadFile) {
        return this.uploadedFirstFile === null;
      }
      if (this.isShowFirstUploadFile && this.isShowSecondUploadFile) {
        return (
          this.uploadedFirstFile === null || this.uploadedSecondFile === null
        );
      }
      return false;
    },
    getType(id) {
      if (this.leaveRequestToEdit) {
        const result = this.leaveRequestsTypes.find(
          (item) => item.value === id
        );
        if (result && result.text) {
          return result.text;
        }
        return this.$t("no-data");
      }
      return this.$t("no-data");
    },
    onchangeStartDate(event) {
      this.onchangeDataType(false);
      if (
        this.leaveRequestToEdit.startDate &&
        this.leaveRequestToEdit.endDate
      ) {
        this.numberDateOff = this.datediff(
          this.leaveRequestToEdit.startDate,
          this.leaveRequestToEdit.endDate);
        this.isExceedMaxDateSolde = false;
        if (!this.isDisableEndPicker && this.numberDateOff >= 7) {
          this.numberDateOff =
            this.numberDateOff - Math.round(this.numberDateOff / 7);
        }
        if (this.numberDateOff >= this.maxDateSolde && this.isShowMaxSoldeDay) {
          this.isExceedMaxDateSolde = true;
        }
      }
    },

    onchangeDataType(isChangeDataType = true) {
      if (isChangeDataType) {
        this.leaveRequestToEdit.startDate = "";
        this.leaveRequestToEdit.endDate = "";
       
        this.isDisableEndPicker = false;
        this.isShowSecondUploadFile = false;
        this.isShowFirstUploadFile = false;
        this.uploadedFirstFile = null;
        this.isShowImage = false;
        this.tempPhoto = "";
        this.isShowSecondImage = false;
        this.tempSecondPhoto = "";
        this.uploadedSecondFile = null;
        this.isDisabledEndDatePicker = false;
        this.fileName = "";
        this.fileSecondName = "";
        this.numberDateOff = 0;
        this.isExceedMaxDateSolde = false;
      }
      if (this.leaveRequestToEdit && this.leaveRequestToEdit.pkIxLeaveType) {
        let date = new Date(this.leaveRequestToEdit.startDate);

        switch (this.leaveRequestToEdit.pkIxLeaveType) {
          case LEAVE_REQUEST_TYPE.CONGES_EXCEPTIONNELS_MARIAGE_PACS: {
            if (this.leaveRequestToEdit.startDate) {
              this.leaveRequestToEdit.endDate = date.setDate(
                date.getDate() + 3
              );
              this.leaveRequestToEdit.endDate = moment(
                this.leaveRequestToEdit.endDate
              ).format("YYYY-MM-DD");
            }
            this.isDisableEndPicker = true;
            this.isShowFirstUploadFile = true;
            this.isDisabledEndDatePicker = true;
            break;
          }
          case LEAVE_REQUEST_TYPE.CONGES_EXCEPTIONNELS_MARIAGE_PACS_UN_ENFANT: {
            if (this.leaveRequestToEdit.startDate) {
              this.leaveRequestToEdit.endDate = date.setDate(date.getDate());
              this.leaveRequestToEdit.endDate = moment(
                this.leaveRequestToEdit.endDate
              ).format("YYYY-MM-DD");
            }
            this.isDisableEndPicker = true;
            this.isShowFirstUploadFile = true;
            this.isDisabledEndDatePicker = true;

            break;
          }
          case LEAVE_REQUEST_TYPE.CONGES_EXCEPTIONNELS_DECES_ENFANT: {
            if (this.leaveRequestToEdit.startDate) {
              this.leaveRequestToEdit.endDate = date.setDate(
                date.getDate() + 11
              );
              this.leaveRequestToEdit.endDate = moment(
                this.leaveRequestToEdit.endDate
              ).format("YYYY-MM-DD");
            }
            this.isDisableEndPicker = true;
            this.isShowFirstUploadFile = true;
            this.isShowSecondUploadFile = true;
            this.isDisabledEndDatePicker = true;
            break;
          }
          case LEAVE_REQUEST_TYPE.CONGES_EXCEPTIONNELS_DECES_PROCHE:
          case LEAVE_REQUEST_TYPE.CONGES_EXCEPTIONNELS_DECES_NAISSANCE_ADOPTION:
          case LEAVE_REQUEST_TYPE.CONGES_EXCEPTIONNELS_DECES_DU_CONJOINT: {
            if (this.leaveRequestToEdit.startDate) {
              this.leaveRequestToEdit.endDate = date.setDate(
                date.getDate() + 2
              );
              this.leaveRequestToEdit.endDate = moment(
                this.leaveRequestToEdit.endDate
              ).format("YYYY-MM-DD");
            }
            this.isDisableEndPicker = true;
            this.isShowFirstUploadFile = true;
            this.isDisabledEndDatePicker = true;

            break;
          }
        }
      }
    },
    datediff(first, second) {
      const diffInMs = new Date(second) - new Date(first);

      const diffInDays = diffInMs > 0 ? diffInMs / (1000 * 60 * 60 * 24) : 0;
      return Math.round(diffInDays) + 1;
    },

    parseDate(str) {
      var mdy = str.split("-");
      return new Date(mdy[0], mdy[2] - 1, mdy[1]);
    },

    handleImageRemove(isFirst) {
      if (isFirst) {
        this.tempPhoto = null;
        this.uploadedFirstFile = null;
        this.fileName = null;
        this.tempFile = null;
        this.isShowImage = false;
      } else {
        this.tempSecondPhoto = null;
        this.uploadedSecondFile = null;
        this.tempSecondFile = null;
        this.fileSecondName = null;
        this.isShowSecondImage = false;

      }
    },

    previewImage: function(event, isFirst) {
      // Reference to the DOM input element

      const vue = this;
      const input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        const size = input.files[0].size / 1024 / 1024;
        const name = event.target.files[0].name;
        const lastDot = name.lastIndexOf(".");

        const ext = name.substring(lastDot + 1);
        let showImage = false;
        showImage = false;
        if (
          ext === "png" ||
          ext === "gif" ||
          ext === "jpeg" ||
          ext === "svg" ||
          ext === "jpg"
        ) {
          showImage = true;
        }
        if (isFirst) {
          vue.isShowImage = showImage;
          vue.uploadedFirstFile = input.files[0];
        } else {
          vue.isShowSecondImage = showImage;
          vue.uploadedSecondFile = input.files[0];
        }

        // if(size > this.maxSizeUploadImage) {
        //   this.callToaster(this.$t('upload-file-max-size-alert').replace('[fileSize]', this.maxSizeUploadImage));
        //   return;
        // }

        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          if (isFirst) {
            this.tempFile = e.target.result;
            if (vue.isShowImage) {
              vue.tempPhoto = e.target.result;
            }
          } else {
            this.tempSecondFile = e.target.result;
            if (vue.isShowSecondImage) {
              vue.tempSecondPhoto = e.target.result;
            }
          }
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },

    getDefaultMessage() {
      let message = "";
      if (this.leaveRequestToEdit && this.leaveRequestToEdit.pkIxLeaveType) {
        switch (this.leaveRequestToEdit.pkIxLeaveType) {
          case LEAVE_REQUEST_TYPE.CONGES_PAYES: {
            message = this.$t("conges-payes-message");
            break;
          }
          case LEAVE_REQUEST_TYPE.CONGES_SANS_SOLDE: {
            message = "";
            break;
          }
          case LEAVE_REQUEST_TYPE.CONGES_PATERNITE: {
            message = this.$t("conges-paternite-message");
            break;
          }
          case LEAVE_REQUEST_TYPE.CONGES_MATERNITE: {
            message = this.$t("conges-maternite-message");
            break;
          }
          case LEAVE_REQUEST_TYPE.CONGES_EXCEPTIONNELS_MARIAGE_PACS: {
            message = this.$t("conges-exceptionnels-mariage-pacs-message");
            break;
          }
          case LEAVE_REQUEST_TYPE.CONGES_EXCEPTIONNELS_MARIAGE_PACS_UN_ENFANT: {
            message = this.$t("conges-exceptionnels-mariage-pacs-un-enfant");
            break;
          }
          case LEAVE_REQUEST_TYPE.CONGES_EXCEPTIONNELS_DECES_ENFANT: {
            message = this.$t("conges-exceptionnels-deces-enfant-message");
            break;
          }
          case LEAVE_REQUEST_TYPE.CONGES_EXCEPTIONNELS_DECES_DU_CONJOINT: {
            message = this.$t("conges-exceptionnels-deces-du-conjoint-message");
            break;
          }
          case LEAVE_REQUEST_TYPE.CONGES_EXCEPTIONNELS_DECES_PROCHE: {
            message = this.$t("conges-exceptionnels-deces-proche-message");
            break;
          }

          case LEAVE_REQUEST_TYPE.CONGES_EXCEPTIONNELS_DECES_NAISSANCE_ADOPTION: {
            message = this.$t(
              "conges-exceptionnels-deces-naissance-adoption-mesage"
            );
            break;
          }
        }
      }
      return message;
    },
    formatData() {
      this.leaveRequestToEdit.startDate = moment(
        this.leaveRequestToEdit.startDate
      ).format("YYYY-MM-DD");
      this.leaveRequestToEdit.endDate = moment(
        this.leaveRequestToEdit.endDate
      ).format("YYYY-MM-DD");
    },
    validateDate(date) {
      if (!this.leaveRequestToEdit.endDate || !date) return null;
      return (
        moment(this.leaveRequestToEdit.endDate).isAfter(
          this.leaveRequestToEdit.startDate
        ) ||
        moment(this.leaveRequestToEdit.endDate).isSame(
          this.leaveRequestToEdit.startDate
        )
      );
    },
    validateType(typeId) {
      if (!typeId) return null;
      return Boolean(typeId);
    },
    onOpenTerminal() {
      this.$refs["terminal-modal"].show();
    },
    onCloseTerminal() {
      this.$refs["terminal-modal"].hide();
    },
    validateBeforeCreateOrUpdate() {
      const { startDate, endDate, pkIxLeaveType } = this.leaveRequestToEdit;
      return (
        !startDate ||
        !endDate ||
        !pkIxLeaveType ||
        !this.validateDate(startDate)
      );
    },
    async createOrUpdateLeaveRequest() {
      if(!this.leaveRequestToEdit.pkIxLeaveType) {
        return;
      }
      if (this.isExceedMaxDateSolde || this.isCheckRequiredFile() ) {
        this.$refs["exceeddate-modal"].show();
        return;
      }
      
      if (this.validateBeforeCreateOrUpdate()) {
        this.callToaster(this.$t("leave-request-enter-all-fields"));
        return;
      }
      this.show = true;
      this.isDisabled = true;
      this.isLoading = true;
      try {
        let data = {
          message: this.leaveRequestToEdit.message,
          startDate: this.leaveRequestToEdit.startDate,
          endDate: this.leaveRequestToEdit.endDate,
          pkIxLeaveType: this.leaveRequestToEdit.pkIxLeaveType,
          file: [],
        };
        if (this.uploadedFirstFile !== null && this.isShowFirstUploadFile) {
          data.file.push(this.tempFile);
        }

        if (this.uploadedSecondFile !== null && this.isShowSecondUploadFile) {
          data.file.push(this.tempSecondFile);
        }

        if (data.file.length == 0) {
          delete data.file;
        }
        const startDate = moment(data.startDate).valueOf();
        const endDate = moment(data.endDate).valueOf();
        data.startDate = startDate;
        data.endDate = endDate;
        if (this.$route.params.type === "edit") {
          const queryId = Number(this.$route.params.id);
          const deleteRes = await leaveRequests.deletedLeaveRequest(
            this.leaveRequestToEdit.pkLeaveRequest
          );
          if (deleteRes) {
            const res = await leaveRequests.createLeaveRequest(data);
            if (res.success) {
              this.isLoading = false;

              const { pkLeaveRequest } = res.data;
              this.$store.commit("LEAVE_REQUEST_SELECTED", {
                ...data,
                pkLeaveRequest,
              });
              this.backtoList();
            } else {
              this.showErrorMessage(res);
              this.isLoading = false;
            }
          } else {
            this.showErrorMessage(deleteRes);
            this.isLoading = false;
          }
        } else {
          const res = await leaveRequests.createLeaveRequest(data);
          if (res.success) {
            this.isLoading = false;
            this.backtoList();
          } else {
            this.isLoading = false;
            this.showErrorMessage(res);
          }
        }
      } catch (error) {
      } finally {
        this.isDisabled = false;
        this.show = false;
        this.isLoading = false;
      }
    },
    async checkFileExistanceDownload(filePath, fileName, isFirst = false) {
      const vue = this;
      let index = isFirst ? 0 : 1;
      return downloadService
        .checkDownloadToken(
          {
            filePath: String.raw`${filePath}`,
          },
          {
            headers: {
              Accept: "application/json",
            },
          }
        )
        .then(function(response) {
          if (response.success) {
            if (!fileName) {
              fileName = filePath
                .split("/")
                .pop()
                .split(".")
                .shift();
              if (isFirst) {
                vue.fileName = fileName + "." + filePath.split(".")[1];
              } else {
                vue.fileSecondName = fileName + "." + filePath.split(".")[1];
              }
            }
            vue.downloadFromToken(response.data.token, filePath, isFirst);
          } else {
            vue.callToaster(`${vue.$t("error-download")}: ${response.message}`);
            if(vue.leaveRequestToEdit.filePath.length==(index+1)) {
              vue.isLoading = false;
              vue.isShowImage = false;
              vue.isShowSecondImage = false;
              vue.tempPhoto = null;
            }
          }
        })
        .catch(function(error) {
          vue.callToaster(vue.$t("error-download") + ".");
          console.error(error);
          if(vue.leaveRequestToEdit.filePath.length==(index+1)) {
            vue.isLoading = false;
            vue.isShowImage = false;
            vue.tempPhoto = null;
            vue.isShowSecondImage = false;
          }
        });
    },
    downloadFromToken(token, filePath, isFirst = false) {
      let index = isFirst ? 0 : 1;
      const vue = this;
      const extension = filePath.split(".")[1];
      let urlFile;
      downloadService
        .downloadFromToken(
          {
            token: token,
          },
          {
            headers: {
              Accept: extension,
            },
            responseType: "arraybuffer",
            dataType: "blob",
          }
        )
        .then(function(response) {
          // var data = window.atob(response.data);

          var blob = new Blob([response], {
            type: extension,
          });
          // var blob = response.data;

          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              "Document-Espace-Adv-Vitalliance.pdf"
            );
          } else {
            urlFile = window.URL.createObjectURL(blob);
            let showImage = false;
            showImage = false;
            if (
              filePath.includes("png") ||
              filePath.includes("gif") ||
              filePath.includes("jpeg") ||
              filePath.includes("svg")
            ) {
              showImage = true;
            }
            var reader = new window.FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function() {
              if (isFirst) {
                vue.tempFile = reader.result;
              } else {
                vue.tempSecondFile = reader.result;
              }
            };
            if (isFirst) {
              vue.tempPhoto = showImage ? urlFile : "";
              vue.uploadedFirstFile = urlFile;
              vue.isShowImage = showImage;
            } else {
              vue.tempSecondPhoto = showImage ? urlFile : "";
              vue.uploadedSecondFile = urlFile;
              vue.isShowSecondImage = showImage;
            }
          }

          if(vue.leaveRequestToEdit.filePath.length==(index+1)) {
            vue.isLoading = false;
          }
        })
        .catch(function(error) {
          // handle error
          vue.isLoading = false;
          vue.callToaster(vue.$t("error-download") + ".");
          console.error(error);
        });
    },
    async deletedLeaveRequest() {
      try {
        const value = await this.$bvModal.msgBoxConfirm(
          this.$t("confirm-delete"),
          {
            title: this.$t("alert-confirm"),
            size: "md",
            buttonSize: "sm",
            okTitle: "OUI",
            okVariant: "primary",
            cancelTitle: "NON",
            cancelVariant: "primary",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        );
        if (value) {
          this.show = true;
          const res = await leaveRequests.deletedLeaveRequest(
            this.leaveRequestToEdit.pkLeaveRequest
          );
          if (res.success) {
            this.callToaster(this.$t("leave-request-deleted"));
            this.backtoList();
          } else {
            this.showErrorMessage(res);
          }
        }
      } catch (error) {
      } finally {
        this.show = false;
      }
    },
    backtoList() {
      this.$router.push({ name: "employee-leave" });
    },
    showErrorMessage(error) {
      if (error.message) {
        this.alert = {
          variant: ALERT_TYPES.DANGER,
          message: error.message,
          show: true,
        };
      }
    },
    async cancelLeaveRequest() {
      try {
        const value = await this.$bvModal.msgBoxConfirm(
          this.$t("confirm-cancel"),
          {
            title: this.$t("alert-confirm"),
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "OUI",
            cancelTitle: "NON",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        );
        if (value) {
          const res = await leaveRequests.cancelLeaveRequest(
            this.leaveRequestToEdit.pkLeaveRequest
          );
          if (res.success) {
            this.callToaster(this.$t("leave-request-canceled"));
            this.backtoList();
          } else {
            this.showErrorMessage(res);
          }
        }
      } catch (error) {}
    },
  },
  watch: {
    uploadedFirstFile(value) {
   
      this.isCheckRequiredFile();
    
    },
    uploadedSecondFile(value) {
     
        this.isCheckRequiredFile()
      
      }
  },
};
